import { useAsyncData, useRouteParams } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function useSellerRatingDetails() {
  const { uuid: id } = useRouteParams()
  const $httpFetch = useHttpFetch()

  return useAsyncData(
    `seller-rating-details-${id}`,
    () =>
      $httpFetch('/reviews/v1/sellers/:uuid/products/reviews/details-summary', {
        pathParams: { uuid: id },
        ...(!import.meta.client && { timeout: 500 }),
      }),
    {
      default: () => null,
    },
  )
}
